import React from 'react'

import { Stack } from '@mui/material'
import { PatientDetailsHeader } from './PatientDetails/PatientDetailsHeader'
import { PatientWarnings } from './PatientDetails/PatientWarnings'
import { PatientLifeStyle } from './PatientDetails/PatientLifeStyle'
import { PatientTreatments } from './PatientDetails/PatientTreatments'
import { PatientMedication } from './PatientDetails/PatientMedication'
import { PatientVaccinations } from './PatientDetails/PatientVaccinations'
import { PatientSurgeries } from './PatientDetails/PatientSurgeries'
import { usePatientEProfile } from '../hooks/usePatientEProfile'

export const PatientDetails: React.FC = () => {
  const data = usePatientEProfile()

  return (
    <Stack px={2} gap={2} pb={2}>
      <PatientDetailsHeader />

      <PatientWarnings {...data} />
      <PatientLifeStyle {...data} />
      <PatientTreatments {...data} />
      <PatientMedication {...data} />
      <PatientVaccinations {...data} />
      <PatientSurgeries {...data} />
    </Stack>
  )
}
